import { connect } from 'react-redux';
import { AppState } from '../../app.state';
import { EquipmentDetailsComponent } from './equipment-details.component';
import {
  addToMap,
  setLastEquipment,
  waitForNewConfig,
  waitForNewStatistic,
} from '../dashboard.actions';

export const EquipmentDetails = connect(
  (sState: AppState) => ({ sState }),
  {
    addToMap,
    setLastEquipment,
    waitForNewConfig,
    waitForNewStatistic,
  }
  //@ts-ignore
)(EquipmentDetailsComponent as any) as unknown as typeof EquipmentDetailsComponent;
